module.exports = __webpack_public_path__ + "static/media/V4.3fdd9c38.mp4";